import countries from 'i18n-iso-countries'
import cs from 'i18n-iso-countries/langs/cs.json'

export const countryOptions = (() => {
  countries.registerLocale(cs)
  const countryOptionsRaw = Object.entries(countries.getNames('cs', { select: 'official' })).map(
    ([code, name]) => ({
      value: name,
      label: name,
    }),
  )

  const czOption = countryOptionsRaw.find((c) => c.value === 'Česká republika')
  const skOption = countryOptionsRaw.find((c) => c.value === 'Slovensko')

  const otherCountries = countryOptionsRaw.filter(
    (c) => c.value !== 'Česká republika' && c.value !== 'Slovensko',
  )
  return [czOption, skOption, ...otherCountries].filter(Boolean)
})()
